import React from 'react'
import BookingsText from '../../static/text/bookings';

function BookingRatesSection() {
    return (
        <div>
            <p className='font-bold'>{BookingsText.intro}</p>
            <div className='py-4 space-y-4'>
                {BookingsText.listings.map((listingObj, key) => {
                    return (
                        <div key={key} className='flex flex-col items-center'>
                            <div className='underline text-lg'>{listingObj.name}</div>
                            <div className='pb-2'>*{listingObj.description}</div>
                            <table>
                                <tbody>
                                    {listingObj.rates.map((rateObj, listingKey) => {
                                        return (
                                            <tr key={listingKey}>
                                                <td className='pr-6 text-right'>{rateObj.listing}</td>
                                                <td className='text-left'>{rateObj.rate}</td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </table>
                        </div>
                    )
                })}
            </div>
            <p>{BookingsText.footnote}</p>
        </div>
    )
}

export default BookingRatesSection